import { Navigate, useLocation } from 'react-router-dom';
import { AppShellSkeleton } from '@/components/core';
import { usePermittedSidebar } from '@/hooks/use-permitted-sidebar';
import { UnauthorizedPage } from '@/modules/error-view/pages/unauthorized';
import { useIsProtected } from './use-is-protected';

type ProtectedRouteProps = {
  roles?: string[];
  permissions?: string[];
  opt?: 'all' | 'any';
  children: React.ReactNode;
};

export const ProtectedRoute = ({
  children,
  opt = 'any',
  roles = [],
  permissions = [],
}: ProtectedRouteProps) => {
  const { isProtected, isAuthenticated, user } = useIsProtected({ roles, permissions, opt });
  const { landingPath } = usePermittedSidebar();
  const { pathname } = useLocation();

  // `ClientMiddleware` mirrors the auth store one effect behind, so on logout or a failed token
  // refresh this guard can render with `isAuthenticated: false` before the middleware reacts.
  // Redirect here directly instead of throwing, which would crash the route tree.
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Right after sign-in the account (and its permissions) is still loading. Deciding now would
  // wrongly bounce the user off a page they are allowed to open.
  if (!user) return <AppShellSkeleton />;

  if (isProtected) return <>{children}</>;

  // No access here: send them to the first menu item they can open. With none, show the 403.
  if (landingPath && landingPath !== pathname) return <Navigate to={landingPath} replace />;

  return <UnauthorizedPage />;
};
